var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M6.99 19 3 15l3.99-4v3H14a2 2 0 0 1-2 2H6.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M10.5 14c3.16 0 3.5-1 3.5-1v1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M21 22a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4h2v4h8V8h-8v4H9V8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"
  })));
};
export default SvgExit;